import { type ReactNode } from 'react';
import { PrivateEventBusContext } from './private-event-bus-context-instance';
import type { PrivateEventBus } from './private-event-bus';

/**
 * Provides a single {@link PrivateEventBus} instance to the React tree.
 * Mount once near the auth boundary in App.tsx.
 */
export function PrivateEventBusProvider({ bus, children }: { bus: PrivateEventBus; children: ReactNode }): ReactNode {
  return <PrivateEventBusContext.Provider value={bus}>{children}</PrivateEventBusContext.Provider>;
}
